import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {switchMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';
import { CommandService } from '@core/services/command.service';
import { FileManagementService } from '@core/services/file-management.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { Go } from '@shared/store/actions/router-extension.action';
import {TransactionConfig} from '../../transaction.config';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {Observable} from 'rxjs';
import {
  TRANSACTION_DATA_TEMPLATE_DOWNLOAD,
  TRANSACTION_IMPORT, TRANSACTION_IMPORT_SUCCESS,
  TRANSACTION_UPLOAD_SOURCE_FILE, TransactionDataTemplateDownloadAction, TransactionDataTemplateDownloadFailedAction,
  TransactionDataTemplateDownloadSuccessAction,
  TransactionImportAction,
  TransactionImportFailAction, TransactionImportSuccessAction,
  TransactionUploadSourceFileAction, TransactionUploadSourceFileFailedAction
} from '../actions/transaction.actions';
import {TransactionImportCommand} from '../../commands/transaction.commands';
import {InvalidateSmartGridAction} from "@shared/store/actions/smart-grid.actions";
@Injectable()
export class TransactionChartImportExportEffect {
  constructor(private actions$: Actions,
              private fileManagementService: FileManagementService,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService) {
  }


  transactionUploadSourceFile$ = createEffect(() => this.actions$
    .pipe( ofType(TRANSACTION_UPLOAD_SOURCE_FILE) )
    .pipe(
      mergeMap((action: TransactionUploadSourceFileAction) => {
        this.fuseSplashScreenService.show();
        return this.fileManagementService.uploadFileWithRelativePath(action.file, action.path, action.overwrite)
          .pipe(
            mergeMap((fileId: string) => {
              return [new TransactionImportAction(new TransactionImportCommand(fileId, action.replaceExistingSelection)),
                new InvalidateSmartGridAction(action.sourceType, true, true, true)];
            }),
            catchError(error => {
              this.fuseSplashScreenService.hide();
              this.snackBarService.showError('Transaction Import Failed');
              return of(new TransactionUploadSourceFileFailedAction(error));
            })
          );
      })
    ));


  transactionImport$ = createEffect(() => this.actions$
    .pipe( ofType(TRANSACTION_IMPORT) )
    .pipe(
      switchMap((action: TransactionImportAction) => {
        return this.commandService.executeCommand(action.command)
          .pipe(
            map(transactionImportNotification => {
              return new TransactionImportSuccessAction(transactionImportNotification.Payload);
            }),
            catchError(error => {
              this.fuseSplashScreenService.hide();
              this.snackBarService.showError('Transaction Import Failed');
              return of(new TransactionImportFailAction(error));
            })
          );
      })
    ));


  transactionImportSuccess$ = createEffect(() => this.actions$
    .pipe( ofType(TRANSACTION_IMPORT_SUCCESS) )
    .pipe(
      map(action => {
        this.fuseSplashScreenService.hide();
        this.snackBarService.showInformation('Transaction Imported');
        return new Go({path: TransactionConfig.TransactionChartUrl});
      })
    ));


  transactionDataTemplateDownload$ = createEffect(() => this.actions$
    .pipe( ofType(TRANSACTION_DATA_TEMPLATE_DOWNLOAD) )
    .pipe(
      switchMap((action: TransactionDataTemplateDownloadAction) => {
        return this.fileManagementService.downloadTemplate(action.fileName)
          .pipe(
            map((payload: any) => {
              // TODO: same code. move in a function
              const url = window.URL.createObjectURL(payload);
              const a = document.createElement('a');
              a.setAttribute('href', url);
              a.setAttribute('target', '_blank');
              a.setAttribute('download', 'Transaction Data Template.xlsx');
              a.style.display = 'none';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              return new TransactionDataTemplateDownloadSuccessAction();
            }),
            catchError(error => of(new TransactionDataTemplateDownloadFailedAction(error)))
          );
      })
    ));
}

